<template>
  <div class="ps-px-6 ps-bg-white ps-mt-6 ps-py-6">
    <div class="ps-flex ps-items-center">
      <div
        v-if="iconName"
        class="ps-flex-shrink-0 ps-flex ps-items-center  ps-text-brand-brown-800"
      >
        <svg-icon :name="iconName" width="25" height="auto" />
      </div>
      <div class="ps-flex-auto">
        <h3 class="ps-text-lg  ps-text-brand-brown-800 ps-font-bold ps-ml-2">
          {{ browser.name }}
        </h3>
      </div>
    </div>
    <div class="ps-text-sm ps-mt-3 ps-leading-normal ps-text-brand-brown-800">
      <p class="ps-flex ps-leading-loose  ps-text-brand-brown">
        <span class="ps-w-32">Version:</span>
        <strong>{{ browser.version }}</strong>
      </p>
      <p v-if="browser.window_size" class="ps-flex ps-mt-1 ps-text-brand-brown">
        <span class="ps-w-32">Browser Window:</span>
        <strong
          >{{ browser.window_size.innerWidth }} x
          {{ browser.window_size.innerHeight }}</strong
        >
      </p>
      <p
        v-if="browser.screen_size"
        class="ps-flex ps-mt-1  ps-text-brand-brown"
      >
        <span class="ps-w-32">Screen Size:</span>
        <strong
          >{{ browser.screen_size.width }} x
          {{ browser.screen_size.height }}</strong
        >
      </p>
      <p class="ps-flex ps-mt-1">
        <span class="ps-w-32">Orientation:</span>
        <strong>{{ browser.orientation || 'NA' }}</strong>
      </p>
      <p
        v-if="browser.scroll_offset"
        class="ps-flex ps-mt-1 ps-text-brand-brown"
      >
        <span class="ps-w-32">Scroll Offset:</span>
        <strong
          >{{ browser.scroll_offset.x }} x {{ browser.scroll_offset.y }}</strong
        >
      </p>
    </div>
    <browser-diagram
      v-if="browser.screen_size && browser.window_size"
      :browser="browser"
    />
  </div>
</template>

<script>
import BrowserDiagram from '@/components/BrowserDiagram'
import '@/icons/edge'
import '@/icons/chrome'
import '@/icons/firefox'
import '@/icons/safari'

export default {
  name: 'BrowserItem',
  props: {
    browser: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BrowserDiagram
  },
  computed: {
    iconName() {
      switch (this.browser.name) {
        case 'Chrome':
          return 'chrome'
        case 'Firefox':
          return 'firefox'
        case 'Edge':
          return 'edge'
        case 'Safari':
          return 'safari'
      }
    }
  }
}
</script>
